import { render } from "./CommentItem.vue?vue&type=template&id=4b3fa75e&scoped=true"
import script from "./CommentItem.vue?vue&type=script&lang=js"
export * from "./CommentItem.vue?vue&type=script&lang=js"

import "./CommentItem.vue?vue&type=style&index=0&id=4b3fa75e&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/PROD/okr-web-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b3fa75e"]])

export default __exports__